export const GET_ONE_GALLERY = "GET_ONE_GALLERY";
export const DELETE_PHOTO = "DELETE_PHOTO";
export const ADD_PHOTOS = "ADD_PHOTOS";